"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _vodafoneLight = _interopRequireDefault(require("./assets/fonts/vodafone-light.woff"));

var _vodafoneRegular = _interopRequireDefault(require("./assets/fonts/vodafone-regular.woff"));

var _vodafoneBold = _interopRequireDefault(require("./assets/fonts/vodafone-bold.woff"));

var _vodafoneExtraBold = _interopRequireDefault(require("./assets/fonts/vodafone-extra-bold.woff"));

var _h, _h2, _h3, _h4, _h5, _theme$overrides$MuiI, _theme$overrides$MuiT, _theme$overrides$MuiC, _theme$overrides$MuiB, _MuiButtonContaine2, _theme$overrides$MuiB2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var palette = {
  type: "light",
  common: {
    black: "#000",
    white: "#fff"
  },
  background: {
    paper: "#fff",
    default: "#fafafa"
  },
  primary: {
    main: "#E60000",
    dark: "#990000",
    contrastText: "#fff"
  },
  secondary: {
    light: "#00B0CA",
    main: "#007C92",
    dark: "#005665",
    contrastText: "#fff"
  },
  error: {
    main: "#e60000",
    dark: "#990000",
    contrastText: "#fff"
  },
  success: {
    light: "#A8B400",
    main: "#009900",
    dark: "#285200",
    contrastText: "rgba(0, 0, 0, 0.87)"
  },
  info: {
    main: "#9C2AA0",
    dark: "#5E2750",
    contrastText: "#fff"
  },
  warning: {
    light: "#FECB00",
    main: "#EB9700",
    contrastText: "rgba(0, 0, 0, 0.87)"
  },
  grey: {
    100: "#F4f4f4",
    200: "#ebebeb",
    300: "#cccccc",
    400: "#AFAFAF",
    500: "#999999",
    600: "#666666",
    700: "#4A4D4E",
    800: "#333333",
    900: "#222222"
  },
  text: {
    primary: "#333333",
    secondary: "#666666",
    disabled: "#999999"
  },
  vodafone: {
    VodafoneGrey: "#4A4D4E",
    VodafoneRed: "#E60000",
    Turquoise: "#007C92",
    AquaBlue: "#00B0CA",
    Aubergine: "#5E2750",
    RedViolet: "#9C2AA0",
    UIGreen: "#009900",
    Maroon: "#990000",
    SpringGreen: "#A8B400",
    FreshOrange: "#EB9700",
    LemonYellow: "#FECB00"
  }
};
var vodafoneLight = {
  fontFamily: 'Vodafone',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: "url(".concat(_vodafoneLight.default, ") format('woff')")
};
var vodafoneRegular = {
  fontFamily: 'Vodafone',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: "url(".concat(_vodafoneRegular.default, ") format('woff')")
};
var vodafoneBold = {
  fontFamily: 'Vodafone',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: "url(".concat(_vodafoneBold.default, ") format('woff')")
};
var vodafoneExtraBold = {
  fontFamily: 'Vodafone',
  fontDisplay: 'swap',
  fontWeight: 900,
  src: "url(".concat(_vodafoneExtraBold.default, ") format('woff')")
};
var fontFamilies = ['Vodafone', 'Arial', 'sans-serif'].join(',');
var fontSize = 14; // px
// Tell Material-UI what's the font-size on the html element.
// 16px is the default font-size used by browsers.

var htmlFontSize = 16;
var coef = fontSize / 14;
var theme = (0, _styles.createMuiTheme)({
  palette: palette,
  // spacing: 4,
  shape: {// borderRadius: 6,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 1024
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [vodafoneLight, vodafoneRegular, vodafoneBold, vodafoneExtraBold]
      }
    },
    MuiCard: {},
    MuiCardContent: {},
    MuiIconButton: {},
    MuiButton: {},
    MuiButtonGroup: {},
    MuiButtonBase: {},
    MuiInputBase: {},
    MuiInputLabel: {},
    MuiOutlinedInput: {},
    MuiPaper: {},
    MuiDialog: {},
    MuiDialogTitle: {},
    MuiDialogContent: {},
    MuiDialogActions: {},
    MuiFormControl: {},
    MuiFormLabel: {},
    MuiMenu: {},
    MuiMenuItem: {},
    MuiTab: {},
    MuiTabs: {},
    MuiDivider: {},
    MuiListItem: {},
    MuiListItemIcon: {},
    MuiSvgIcon: {},
    MuiStepper: {},
    MuiStepIcon: {},
    MuiStepLabel: {},
    MuiStepConnector: {},
    MuiTypography: {},
    MuiCheckbox: {},
    MuiRadio: {},
    MuiCardActionArea: {},
    MuiRating: {},
    MuiGrid: {},
    MuiTextField: {},
    MuiTouchRipple: {},
    MuiSwitch: {},
    MuiPickersBasePicker: {},
    MuiTooltip: {}
  }
});
theme.typography = {
  htmlFontSize: 16,
  pxToRem: function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  },
  fontFamily: fontFamilies,
  fontSize: 18,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: (_h = {
    fontSize: "64px",
    lineHeight: "72px",
    fontWeight: "300"
  }, _defineProperty(_h, theme.breakpoints.down("md"), {
    fontSize: "56px",
    lineHeight: "62px"
  }), _defineProperty(_h, theme.breakpoints.down("sm"), {
    fontSize: "32px",
    lineHeight: "40px"
  }), _h),
  h2: (_h2 = {
    fontSize: "56px",
    lineHeight: "62px",
    fontWeight: "300"
  }, _defineProperty(_h2, theme.breakpoints.down("md"), {
    fontSize: "40px",
    lineHeight: "48px"
  }), _defineProperty(_h2, theme.breakpoints.down("xs"), {
    fontSize: "28px",
    lineHeight: "36px"
  }), _h2),
  h3: (_h3 = {
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: "300"
  }, _defineProperty(_h3, theme.breakpoints.down("md"), {
    fontSize: "34px",
    lineHeight: "40px"
  }), _defineProperty(_h3, theme.breakpoints.down("xs"), {
    fontSize: "24px",
    lineHeight: "30px"
  }), _h3),
  h4: (_h4 = {
    fontSize: "28px",
    lineHeight: "34px",
    fontWeight: "300"
  }, _defineProperty(_h4, theme.breakpoints.down("md"), {
    fontSize: "24px",
    lineHeight: "30px"
  }), _defineProperty(_h4, theme.breakpoints.down("xs"), {
    fontSize: "20px",
    lineHeight: "28px"
  }), _h4),
  h5: (_h5 = {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: "300"
  }, _defineProperty(_h5, theme.breakpoints.down("md"), {
    fontSize: "20px",
    lineHeight: "28px"
  }), _defineProperty(_h5, theme.breakpoints.down("xs"), {
    fontSize: "18px",
    lineHeight: "24px"
  }), _defineProperty(_h5, "&.bold", {
    fontWeight: 700
  }), _h5),
  body1: _defineProperty({
    fontSize: "18px",
    lineHeight: "24px",
    fontWeight: "400"
  }, theme.breakpoints.down("xs"), {
    fontSize: "16px",
    lineHeight: "22px"
  }),
  body2: _defineProperty({
    fontSize: "16px",
    lineHeight: "22px",
    fontWeight: "400"
  }, theme.breakpoints.down("xs"), {
    fontSize: "14px",
    lineHeight: "20px"
  }),
  caption: {
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "400"
  }
};
theme.props = {
  MuiButton: {// disableRipple: true,
  },
  MuiCheckbox: {
    disableRipple: true
  },
  MuiRadio: {
    disableRipple: true
  }
};
theme.overrides.MuiGrid.root = {
  lineHeight: 1
};
theme.overrides.MuiMenuItem.root = {
  minHeight: null
};
theme.overrides.MuiRating.root = {
  display: "flex"
};
theme.overrides.MuiTypography.root = {
  fontFamily: fontFamilies,
  "&.MuiTypography-bold": {
    fontWeight: 700
  },
  "&.MuiTypography-dense": {
    lineHeight: 1
  }
};
theme.overrides.MuiTypography.gutterBottom = {
  marginBottom: theme.spacing(1)
};
theme.overrides.MuiCardActionArea.root = {
  "&.Mui-disabled": {
    opacity: 0.4
  }
};
theme.overrides.MuiInputLabel.formControl = {
  "&.Mui-disabled": {
    color: theme.palette.common.black
  }
};
theme.overrides.MuiInputLabel.outlined = (_theme$overrides$MuiI = {}, _defineProperty(_theme$overrides$MuiI, theme.breakpoints.down("xs"), {
  transform: "translate(14px, 13px) scale(1)"
}), _defineProperty(_theme$overrides$MuiI, "&.MuiInputLabel-shrink", _defineProperty({}, theme.breakpoints.down("xs"), {
  transform: "translate(14px, -11px)"
})), _theme$overrides$MuiI);
theme.overrides.MuiSvgIcon.root = {
  display: "block"
};
theme.overrides.MuiSvgIcon.fontSizeLarge = {
  fontSize: "32px"
};
theme.overrides.MuiFormLabel.root = {
  "&.Mui-focused": {
    color: theme.palette.secondary.main
  },
  "&.Mui-disabled": {
    color: theme.palette.common.black
  }
};
theme.overrides.MuiListItemIcon.root = {
  minWidth: theme.spacing(3),
  marginRight: theme.spacing(1)
};
theme.overrides.MuiDivider.root = {
  backgroundColor: theme.palette.grey[100]
};
theme.overrides.MuiOutlinedInput.root = {
  "&.Mui-focused": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.secondary.main,
      borderWidth: 2
    }
  }
};
theme.overrides.MuiOutlinedInput.notchedOutline = {
  borderColor: theme.palette.grey[500]
};
theme.overrides.MuiInputBase.root = {
  backgroundColor: theme.palette.common.white,
  fontFamily: fontFamilies,
  "&.MuiOutlinedInput-root": {
    "&.Mui-disabled": {
      color: theme.palette.grey["500"],
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.grey[500]
      },
      "& fieldset": {
        "& legend": {
          color: theme.palette.common.black
        }
      }
    }
  }
};
theme.overrides.MuiInputBase.input = {
  "&.Mui-disabled": {
    color: theme.palette.grey["500"],
    borderColor: theme.palette.grey["500"]
  },
  "&::placeholder": {
    color: theme.palette.text.secondary
  }
};
theme.overrides.MuiTabs.root = {};
theme.overrides.MuiTabs.indicator = {
  height: 3
};
theme.overrides.MuiTab.root = (_theme$overrides$MuiT = {
  fontSize: theme.typography.h5.fontSize,
  lineHeight: theme.typography.h5.lineHeight,
  color: theme.palette.text.secondary,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  padding: undefined,
  textTransform: undefined,
  minWidth: undefined,
  "&$selected": {
    fontWeight: 700,
    color: theme.palette.text.primary
  },
  "&:hover": {
    color: theme.palette.text.primary
  }
}, _defineProperty(_theme$overrides$MuiT, theme.breakpoints.up("sm"), {
  minWidth: undefined
}), _defineProperty(_theme$overrides$MuiT, theme.breakpoints.down("xs"), {
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2)
}), _theme$overrides$MuiT);
theme.overrides.MuiTab.textColorInherit = {
  opacity: 1,
  color: undefined
};
theme.overrides.MuiTab.wrapper = {
  flexDirection: "row",
  alignItems: "center",
  "& > *:first-of-type": {
    marginRight: theme.spacing(1)
  }
};
theme.overrides.MuiTab.labelIcon = {
  "& .MuiTab-wrapper > *:first-of-type": {
    marginBottom: 0
  }
};
theme.overrides.MuiCard.root = {};
theme.overrides.MuiCardContent.root = (_theme$overrides$MuiC = {
  padding: theme.spacing(2.5)
}, _defineProperty(_theme$overrides$MuiC, theme.breakpoints.down("xs"), {
  padding: theme.spacing(2)
}), _defineProperty(_theme$overrides$MuiC, "&:last-child", {
  margin: null,
  paddingBottom: undefined
}), _theme$overrides$MuiC);
theme.overrides.MuiIconButton.root = {
  "&.MuiIconButton-colorWhite": {
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.common.white, 0.04)
    },
    "& .MuiSvgIcon-root": {
      "& path": {
        fill: theme.palette.common.white
      }
    }
  }
};
theme.overrides.MuiIconButton.colorSecondary = {
  color: "blue",
  "&:hover": {
    backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.30)
  },
  "& .MuiSvgIcon-root": {
    "& path": {
      fill: theme.palette.primary.main
    }
  }
};
theme.overrides.MuiButton.containedPrimary = {
  height: 40
};
theme.overrides.MuiButton.root = (_theme$overrides$MuiB = {
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  textTransform: "none",
  fontSize: 20,
  lineHeight: "24px",
  height: 40,
  borderRadius: 6,
  fontFamily: fontFamilies
}, _defineProperty(_theme$overrides$MuiB, theme.breakpoints.down("sm"), {
  fontSize: 18,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}), _defineProperty(_theme$overrides$MuiB, "&.MuiButton-outlinedPrimary", {
  color: "#222222",
  borderColor: "#222222",
  "&:hover": {
    color: "#FFFFFF",
    background: "#222222"
  }
}), _defineProperty(_theme$overrides$MuiB, "&.MuiButton-outlinedSecondary", {
  color: theme.palette.primary.main,
  borderColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.5),
  "& path": {
    fill: theme.palette.primary.main
  }
}), _defineProperty(_theme$overrides$MuiB, "&.Mui-active", {
  position: "relative",
  "&:before": {
    content: "''",
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    borderColor: theme.palette.secondary.main,
    borderStyle: "solid",
    borderWidth: 3,
    borderRadius: 6
  }
}), _defineProperty(_theme$overrides$MuiB, "&.Mui-disabled", {
  color: theme.palette.grey[500] // backgroundColor: theme.palette.grey[50],

}), _theme$overrides$MuiB);
theme.overrides.MuiButton.contained = {
  boxShadow: "none",
  color: theme.palette.common.white,
  backgroundColor: theme.palette.grey[600],
  "&:hover": {
    backgroundColor: theme.palette.grey[800],
    color: theme.palette.common.white,
    boxShadow: "none"
  },
  "&.Mui-disabled": {
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.grey[300]
  },
  "&.MuiButton-no-round": {
    borderRadius: 0
  },
  "&.MuiButton-containedLight": {
    backgroundColor: theme.palette.grey[100],
    "& .MuiSvgIcon-root": {
      "& path": {
        fill: theme.palette.text.primary
      },
      "& rect": {
        fill: theme.palette.text.primary
      },
      "& circle": {
        fill: theme.palette.text.primary
      },
      "& polygon": {
        fill: theme.palette.text.primary
      }
    },
    "& .MuiTouchRipple-ripple": {
      "& .MuiTouchRipple-child": {
        backgroundColor: theme.palette.text.primary
      }
    },
    "&:hover": {
      "& .MuiSvgIcon-root": {
        "& path": {
          fill: theme.palette.primary.main
        },
        "& rect": {
          fill: theme.palette.primary.main
        },
        "& circle": {
          fill: theme.palette.primary.main
        },
        "& polygon": {
          fill: theme.palette.primary.main
        }
      }
    }
  },
  "&.MuiButton-containedWhite": {
    backgroundColor: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.grey[100]
    }
  },
  "&.MuiButton-containedTransparent": {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: theme.palette.grey[100]
    }
  },
  "&.MuiButton-containedSelected": {
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark
    },
    "&.Mui-disabled": {
      color: theme.palette.grey[800],
      backgroundColor: theme.palette.grey[50],
      "& .MuiSvgIcon-root": {
        stroke: theme.palette.grey[800]
      }
    }
  },
  "&.MuiButton-containedRounded": {
    borderRadius: "100%"
  },
  "&.MuiButton-containedFloatIcon": (_MuiButtonContaine2 = {
    width: theme.spacing(6),
    minWidth: theme.spacing(6),
    height: theme.spacing(6),
    padding: 0
  }, _defineProperty(_MuiButtonContaine2, theme.breakpoints.down("sm"), {
    width: theme.spacing(5),
    minWidth: theme.spacing(5),
    height: theme.spacing(5)
  }), _defineProperty(_MuiButtonContaine2, theme.breakpoints.down("xs"), {}), _defineProperty(_MuiButtonContaine2, "&.MuiButton-containedSizeSmall", _defineProperty({
    width: theme.spacing(4),
    minWidth: theme.spacing(4),
    height: theme.spacing(4)
  }, theme.breakpoints.down("sm"), {
    width: theme.spacing(3),
    minWidth: theme.spacing(3),
    height: theme.spacing(3),
    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2)
    }
  })), _defineProperty(_MuiButtonContaine2, "&.MuiButton-containedSizeLarge", {
    width: theme.spacing(6),
    minWidth: theme.spacing(6),
    height: theme.spacing(6)
  }), _MuiButtonContaine2),
  "&.MuiButton-containedIcon": {
    width: theme.spacing(5),
    minWidth: theme.spacing(5),
    height: theme.spacing(5),
    padding: 0,
    "&.MuiButton-containedSizeSmall": {
      width: theme.spacing(4),
      minWidth: theme.spacing(4),
      height: theme.spacing(4) // [theme.breakpoints.down("sm")]: {
      //   width: theme.spacing(3),
      //   minWidth: theme.spacing(3),
      //   height: theme.spacing(3),
      //   "& svg": {
      //     width: theme.spacing(2),
      //     height: theme.spacing(2),
      //   }
      // },

    },
    "&.MuiButton-containedSizeLarge": {
      width: theme.spacing(6),
      minWidth: theme.spacing(6),
      height: theme.spacing(6)
    },
    "&.MuiButton-containedSizeXLarge": {
      width: theme.spacing(7.5),
      minWidth: theme.spacing(7.5),
      height: theme.spacing(7.5)
    }
  }
};
theme.overrides.MuiButton.containedSizeSmall = {
  fontSize: undefined
};
theme.overrides.MuiButton.outlined = (_theme$overrides$MuiB2 = {
  color: theme.palette.grey[800],
  borderColor: theme.palette.grey[500],
  backgroundColor: "transparent",
  paddingTop: theme.spacing(1) + 1,
  paddingBottom: theme.spacing(1) + 1,
  padding: undefined
}, _defineProperty(_theme$overrides$MuiB2, theme.breakpoints.down("sm"), {
  paddingTop: theme.spacing(1) - 1,
  paddingBottom: theme.spacing(1) - 1
}), _defineProperty(_theme$overrides$MuiB2, "&:hover", {
  borderColor: theme.palette.grey[500],
  backgroundColor: theme.palette.grey[100]
}), _defineProperty(_theme$overrides$MuiB2, "&.Mui-disabled", {
  color: theme.palette.grey[800],
  backgroundColor: theme.palette.common.white,
  borderColor: theme.palette.common.white
}), _theme$overrides$MuiB2);
theme.overrides.MuiButton.sizeSmall = {
  fontSize: 16,
  lineHeight: "22px",
  height: 30
};
theme.overrides.MuiButton.iconSizeMedium = {
  "& > *:first-of-type": {
    fontSize: 24
  }
};
theme.overrides.MuiButtonBase.root = {
  fontFamily: fontFamilies,
  "& .MuiCardActionArea-focusHighlight": {
    backgroundColor: "transparent"
  },
  "&:hover": {
    "& .MuiCardActionArea-focusHighlight": {
      backgroundColor: "transparent"
    }
  }
};
theme.overrides.MuiButtonGroup.contained = {
  boxShadow: "none",
  "& .MuiButton-contained:hover": {
    boxShadow: "none"
  }
};
theme.overrides.MuiTouchRipple.child = {
  backgroundColor: theme.palette.grey[900]
};
theme.overrides.MuiSwitch.root = {
  width: 40,
  height: 24,
  padding: 0,
  marginTop: 6,
  marginBottom: 6,
  marginLeft: 6,
  marginRight: 6
};
theme.overrides.MuiSwitch.switchBase = {
  padding: 0,
  left: 1,
  top: 1,
  "&.Mui-checked": {
    transform: "translateX(16px)",
    "& + .MuiSwitch-track": {
      opacity: 1
    }
  },
  "&.Mui-disabled": {
    "& + .MuiSwitch-track": {
      opacity: 1
    }
  }
};
theme.overrides.MuiSwitch.track = {
  borderRadius: 26 / 2,
  backgroundColor: theme.palette.grey[500],
  opacity: 1,
  transition: theme.transitions.create(['background-color']),
  "&.Mui-disabled": {
    backgroundColor: theme.palette.grey[300]
  }
};
theme.overrides.MuiSwitch.thumb = {
  width: 22,
  height: 22,
  backgroundColor: theme.palette.common.white,
  "&.Mui-disabled": {
    backgroundColor: theme.palette.grey[200]
  }
};
theme.overrides.MuiSwitch.colorSecondary = {
  "&.Mui-disabled": {
    "& + .MuiSwitch-track": {
      backgroundColor: theme.palette.grey[300]
    }
  }
};
theme.overrides.MuiSwitch.sizeSmall = {
  width: 28,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    left: 2,
    top: 2,
    "&.Mui-checked": {
      transform: "translateX(8px) !important"
    }
  }
};
theme.overrides.MuiTooltip.tooltip = {
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  backgroundColor: theme.palette.common.white,
  boxShadow: "0 4px 10px rgba(0,0,0,0.32)",
  color: theme.palette.grey[800],
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.body1.lineHeight,
  borderRadius: 6
};
var _default = theme;
exports.default = _default;